import {
  updateUserInterests
} from "./chunk-RFON2F2H.mjs";

// src/hooks/wbk/favorites/update.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useUpdateUserInterests = ({ lang }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateUserInterests,
    onSuccess: (data) => {
      return queryClient.setQueryData(["user", { lang }], data);
    }
  });
};

export {
  useUpdateUserInterests
};
//# sourceMappingURL=chunk-W6RTPVFY.mjs.map